'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('systemOwnerUserRequestControllers')

    .controller('MainSystemOwnerUserRequestController', ['$scope', '$rootScope', '$state', '$translate', 'topBar', 'cardsToProcess',
        function ($scope, $rootScope, $state, $translate, topBar, cardsToProcess) {

    $scope.cardsToProcess = cardsToProcess;

    $translate('iam.systemOwnerUserRequest.pageTitle').then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa-gavel');
    });

    $scope.confCards = {
        NetworkShareCard: {
            template: '/app/Main/systemOwnerUserRequest/CardNetworkShare.tpl.html',
            controller: 'CardNetworkShareController'
        },
        SystemRolePendingCard: {
            template: '/app/Main/systemOwnerUserRequest/CardSystemRolePending.tpl.html',
            controller: 'CardSystemRolePendingController'
        },
    };

    $scope.getTemplateAndControllerCard = function (card) {
        return $scope.confCards[card.CardClass];
    }

    $scope.approveAll = function () {
        $rootScope.$broadcast('systemowner-userrequest-approve-all');
    }

    var flattenedCards = _.flatten(cardsToProcess.GroupsOfCards);

    $scope.$on('systemowner-userrequest-approve-reject', function (event, args) {
        var foundNotProcessed = _.findIndex(flattenedCards, function (card) {
            return _.isUndefined(card.isToProcess);
        });

        if (foundNotProcessed === -1) {
            window.location = environment.iamUrl;
        }
    });
}]);
